import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { urls } from "../../urls";
import { useLoggedInWithOrgContextState } from "../auth/useLoggedInWithOrgContextState";
import { useViewport } from "../hooks/useViewport";
import { usePageFrame } from "../layout/pageFrame";
import { useSidebarMode } from "../layout/sidebarMode";
import { useAssistantPanel } from "./assistantPanelContext";
import { type PanelPlacement, placementFor, widthSwitchApplies } from "./panelPlacement";
import { panelWidthPreference } from "./panelPreferences";

export type PanelLayout = { placement: PanelPlacement | null; widthSwitchApplies: boolean };

export const usePanelPlacement = (): PanelLayout => {
  const { panelOpen } = useAssistantPanel();
  const { pathname } = useLocation();
  const personId = useLoggedInWithOrgContextState().me.id;
  const [choice] = panelWidthPreference.use(personId);
  const { mode } = useSidebarMode(personId);
  const { hasShell, ownSideColumnFromEm } = usePageFrame();
  const { width, remPx } = useViewport();
  const shown = panelOpen && pathname !== urls.app.assistant;

  return useMemo(() => {
    if (!shown) return { placement: null, widthSwitchApplies: false };
    const room = { windowWidth: width, remPx, menuHidden: mode === "icons", hasShell, ownSideColumnFromEm };
    return { placement: placementFor({ ...room, choice }), widthSwitchApplies: widthSwitchApplies(room) };
  }, [shown, width, remPx, choice, mode, hasShell, ownSideColumnFromEm]);
};
